module.exports = __webpack_public_path__ + "portal-static/img/VR_decor_ico_01.f031d9cc.png";